module.exports = __webpack_public_path__ + "static/media/A3.3f7578db.jpg";